<template>
    <div class="list">
        <div class="list-item" v-for="item in list" :key="item.renovationId" @click="handleDetail(item)">
            <div class="info">
                <span>{{ item.name }}</span> -
                <span>{{ item.plazaName }}</span> -
                <span>{{ item.storeName }}</span>
            </div>
            <div class="work worker">
                施工方：{{ item.companyName }}
            </div>
            <div class="work time">
                施工时间：{{ item.renovationTime }}
            </div>
        </div>

    </div>
</template>

<script>
import { apiGetList } from '@/api/outInCard.js';
export default {
  computed: {
    userId() {
      return this.$route.query.userId
    }
  },
  data() {
    return {
      list: []
    }
  },
  methods: {
    getList() {
      this.$toast.loading({
        message:'加载中...',
        duration:0
      })
      apiGetList(this.userId).then(res => {
        this.$toast.clear()
        this.list = res
      })
    },
    handleDetail(item) {
      this.$router.push({
        path: '/outInDetail',
        query: {
          id: item.renovationId,
          idNo: item.idNo
        }
      })
    }

  },
  mounted() {
    this.getList()
  }

}
</script>


<style lang="less" scoped>
.list {
    background-color: #F6F7FB;
    padding: 25px 0 10px 0;
    text-align: left;
    line-height: 1;
    overflow: auto;
    box-sizing: border-box;

    .list-item {
        margin-bottom: 15px;
        padding: 15px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);

        .info {
            font-size: 16px;
            color: #666;
            font-weight: 600;
        }

        .work {
            font-size: 12px;
            color: #666660;
        }

        .worker {
            margin-top: 20px;
        }

        .time {
            margin-top: 8px;
        }
    }
}
</style>